module.exports = __webpack_public_path__ + "img/Vbg1.20d1014f.png";